export const AUTH_TOKEN_PARAM = 'token'
export const LOGIN_PARAM = 'login'
export const RESERVE_ITEM_PARAM = 'reserve'
